import * as React from 'react';
import SmWorkbenchList, {
  WorkbenchListProps,
} from 'containers/SmWorkbench/components/List';
import { Button } from '@beehive/components';
import { connect } from 'react-redux';
import * as actions from 'modules/actions/lsWorkbench';
import _ from 'lodash';

class LsWorkbenchList extends React.Component<WorkbenchListProps> {
  getColumns = () => {
    const { getColumns } = this.props;
    return {
      id: {
        width: 150,
        render: (v: any, r: any, i: number) => {
          return (
            <Button
              href={`/#/lsWorkbench/projectDetailSingle/${v}`}
              target="_blank"
            >
              {v}
            </Button>
          );
        },
      },
      ...getColumns && getColumns(),
    };
  }

  render() {
    return <SmWorkbenchList {...this.props} getColumns={this.getColumns} />;
  }
}

const mapState2Props = (state: any, ownProps: any) => {
  const { menuKey } = ownProps;
  const data = state.lsWorkbench[_.snakeCase(menuKey)];
  return {
    data,
  };
};

const mapDispatchToProps = () => {
  return {
    getList: actions.getList,
    getFilterOptions: actions.getFilterOptions,
    changeConditions: actions.changeConditions,
    changeCheck: actions.changeCheck,
  };
};

export default connect(
  mapState2Props,
  mapDispatchToProps,
)(LsWorkbenchList);
